import React, { PureComponent } from 'react';
import './Table.scss';
import classnames from 'classnames';

interface ChildProps {
  children?: React.ReactNode,
}

const Header: React.FC<ChildProps> = ({ children = <></> }): JSX.Element => (
  <thead>{children}</thead>);

const Body: React.FC<ChildProps> = ({ children = <></> }): JSX.Element => (
  <tbody>{children}</tbody>);

const Footer: React.FC<ChildProps> = ({ children = <></> }): JSX.Element => (
  <tfoot>{children}</tfoot>);

interface Props {
  isWithBorder?: boolean,
  children: React.ReactNode,
}

class Table extends PureComponent<Props, {}> {
  static Header = Header;

  static Body = Body;

  static Footer = Footer;

  render() {
    const { children, isWithBorder } = this.props;
    const classes = classnames({
      'table--withBorder': isWithBorder,
    });
    return (
      <div className="table">
        <table className={classes}>
          {children}
        </table>
      </div>
    );
  }
}

Table.Header = Header;
Table.Body = Body;
Table.Footer = Footer;

export default Table;
